import { formatInTimeZone } from 'date-fns-tz';
import { NZ_TIMEZONE } from './announcementTime';

const TE_REO_LANGUAGE_WEEK_START = '2026-09-14';
const TE_REO_LANGUAGE_WEEK_END = '2026-09-18';

export const isTeReoLanguageWeek = (date: Date = new Date()): boolean => {
  const nzDate = formatInTimeZone(date, NZ_TIMEZONE, 'yyyy-MM-dd');

  return nzDate >= TE_REO_LANGUAGE_WEEK_START && nzDate <= TE_REO_LANGUAGE_WEEK_END;
};
